import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@chakra-ui/react';
import {Header} from './Header';
import Content from './Content';
import posthog from 'posthog-js';

export class Page extends React.Component {
    state = {
        message: this.props.message ? this.props.message : '',
        chatClient: this.props.chatClient ? this.props.chatClient : 'slack-white',
    };

    handleMessageChange = event => {
        this.setState({message: event.target.value});
    };

    handleClientClick = event => {
        const id = event.currentTarget.id;
        const next = id === 'slack' ? 'slack-white' : id;
        
        // Track analytics
        if (id === 'slack' || id === 'discord') {
            // Track Slack vs Discord button click
            posthog.capture('chat_client_selected', {
                client: id === 'slack' ? 'slack' : 'discord'
            });
        } else if (id.startsWith('slack-')) {
            // Track Slack color profile selection
            const colorProfile = id.replace('slack-', '');
            posthog.capture('slack_color_profile_selected', {
                color_profile: colorProfile
            });
        }
        
        this.setState({chatClient: next});
    };


    render() {
        return (
            <Box>
                <Header/>
                <Content message={this.state.message} chatClient={this.state.chatClient}
                         onMessageChange={this.handleMessageChange} onClientClick={this.handleClientClick}/>
            </Box>
        );
    }
}

Page.propTypes = {
    message: PropTypes.string,
};

Page.defaultProps = {
    message: '',
};
